import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import routes from './routes';
import axios from 'axios'

Vue.use(VueRouter);

Vue.prototype.navigateTo = function(link) {
	if (this.$route.fullPath.includes('/window/')) {
		this.$router.push(`/window${this.$router.resolve(link).href}`);
	} else {
		this.$router.push(link);
	}
};
Vue.prototype.navigateBack = function(n = -1) {
	this.$router.go(n);
};
Vue.prototype.redirectTo = function(link) {
	this.$router.replace(link);
};

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes
});

const app = new Vue();
let frequentRouteNames = [];
let frequentRouteTimer = null;

function recordFrequentRoute(routeName) {
	if (!routeName || !/^m_[A-Za-z0-9_]{1,61}$/.test(routeName)) return;
	if (!frequentRouteNames.includes(routeName)) {
		frequentRouteNames.push(routeName);
	}
	clearTimeout(frequentRouteTimer);
	frequentRouteTimer = setTimeout(() => {
		let routeNames = frequentRouteNames.join(',');
		frequentRouteNames = [];
		routeNames && app.request({url: '/workbench/frequent/visit', data: {route_names: routeNames}});
	}, 800);
}

router.beforeEach(async function(to, from, next) {
	if (await new Promise(resolve => {
		axios.get(`//${window.location.host}/version.json?t=${new Date().getTime()}`).then(res => {
			if (res.status === 200) {
				if (window.sysVersion && window.sysVersion != res.data.version) {
					resolve(true);
				} else {
					window.sysVersion = res.data.version;
				}
			}
			resolve(false);
		}).catch(e => {
			console.error(e);
			resolve(false);
		});
	})) {
		window.location.href = router.resolve(to).href;
	}

	let redirect;
	if (!to.meta.loginFree) {
		if (!store.state.session) {
			redirect = `/login?redirect=${to.fullPath}`;
		} else if (to.name && !to.meta.authFree && !app.auth(to.name)) {
			redirect = '/';
		}
	}

	next(redirect);
});

// 仅在路由守卫完成后记录实际进入的业务页面，参数变更不会重复计数。
router.afterEach(function(to, from) {
	if (store.state.session && to.name !== from.name) {
		recordFrequentRoute(to.name);
	}
});

export default router